import React from 'react';
import { Switch } from 'react-router-dom';

import Route from 'routes/Route';

import Login from 'pages/Login';
import Balance from 'pages/Balance';
import Reports from 'pages/Reports';
import NotFound from 'pages/NotFound';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Login} />
    <Route path="/balance" component={Balance} isPrivate />
    <Route path="/reports" component={Reports} isPrivate />
    <Route component={NotFound} />
  </Switch>
);

export default Routes;
